import angular from 'angular';
import $ from 'jquery';

export default class UserTradingDetails {
  constructor($scope, UserService, UserAdminMessageService, UiService) {
    $scope.tabs = ['General', 'Admin Messages', 'Newsletter Settings'];

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
    };

    $scope.open_dialog = function(dialog_id) {
      window.openFancyboxDialog('div#' + dialog_id);
    };

    $scope.add_message = function() {
      $scope.dialog_message = angular.copy(window.admin_message);
      $scope.open_dialog('user_admin_message_dialog');
    };

    $scope.edit_message = function(message) {
      $scope.dialog_message = message;
      $scope.open_dialog('user_admin_message_dialog');
    };

    $scope.delete_message = function(index) {
      if (confirm('Are you sure you want to delete this message?')) {
        UserAdminMessageService.delete($scope.user_admin_messages[index].id).then(function(data) {
          if (data.success)
            $scope.user_admin_messages.splice(index, 1);
        });
      }
    };

    $scope.save_message = function() {
      $scope.updating_message = true;
      UserAdminMessageService.save($scope.dialog_message).then(function(data) {
        if (data.success) {
          $scope.updating_message = false;
          $.fancybox.close();
          $scope.user_admin_messages = data.user_admin_messages;
        }
      });
    };

    $scope.update_newsletter_settings = function() {
      $scope.updating_newsletter_settings = true;
      UserService.update_supplier_newsletter_settings(window.user_id, $scope.newsletter_settings).success(function(data) {
        if (data.success)
          $scope.updating_newsletter_settings = false;
      });
    };

    $scope.init = function() {
      $scope.selected_tab = 0;
      $scope.tinymceOptions = UiService.tinymceOptions();
      $scope.user_admin_messages = window.user_admin_messages;
      $scope.dialog_message = angular.copy(window.admin_message);
      $scope.newsletter_settings = window.newsletter_settings || {
        offer_campaign_text: null,
        offer_campaign_text_el: null,
        offer_campaign_text_el_per: null
      };
      $scope.is_buyer = window.is_buyer;
    };

    $scope.init();
  }
}

UserTradingDetails.$inject = ['$scope', 'UserService', 'UserAdminMessageService', 'UiService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-trading-details.ctrl.js